import { B, PROFILES } from "../constants";

export default function ProfileSelect({ onSelect }) {
  return (
    <div style={{minHeight:"100vh",background:B.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"IBM Plex Mono,monospace"}}>
      <div style={{fontSize:11,letterSpacing:"0.2em",color:B.accent,textTransform:"uppercase",fontWeight:600,marginBottom:8}}>FYNWELL</div>
      <h1 style={{fontSize:20,fontWeight:600,color:B.text,marginBottom:4,margin:0}}>Who's viewing?</h1>
      <div style={{fontSize:12,color:B.muted,marginBottom:32,fontFamily:"IBM Plex Sans,sans-serif"}}>Select your profile</div>
      <div style={{display:"flex",flexDirection:"column",gap:12,width:"100%",maxWidth:320}}>
        {Object.values(PROFILES).map(p=>(
          <button key={p.id} onClick={()=>onSelect(p.id)} aria-label={`Select profile: ${p.name}, ${p.role}`}
            style={{padding:"18px 20px",borderRadius:16,border:`1px solid ${p.color}33`,background:`${p.color}08`,cursor:"pointer",display:"flex",alignItems:"center",gap:14,textAlign:"left"}}>
            <div aria-hidden="true" style={{width:44,height:44,borderRadius:12,background:`${p.color}22`,border:`1px solid ${p.color}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:700,color:p.color,flexShrink:0}}>{p.avatar}</div>
            <div>
              <div style={{fontSize:14,fontWeight:600,color:B.text}}>{p.name}</div>
              <div style={{fontSize:11,color:B.muted,marginTop:2,fontFamily:"IBM Plex Sans,sans-serif"}}>{p.role}</div>
            </div>
          </button>
        ))}
        <button onClick={()=>onSelect("both")} style={{padding:"14px 20px",borderRadius:16,border:`1px solid ${B.border}`,background:"rgba(255,255,255,0.02)",cursor:"pointer"}}>
          <span style={{fontSize:12,color:B.muted}}>View household combined</span>
        </button>
      </div>
    </div>
  );
}
